//Reset data
export const RESET = "DASHBOARD_LIST_RESET"

//Loading
export const SET_TOGGLE_LOADING = "DASHBOARD_LIST_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "DASHBOARD_LIST_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "DASHBOARD_LIST_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "DASHBOARD_LIST_SET_MESSAGE"
export const SET_IS_SUCCESS = "DASHBOARD_LIST_SET_IS_SUCCESS"
export const SET_IS_ERROR = "DASHBOARD_LIST_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "DASHBOARD_LIST_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "DASHBOARD_LIST_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "DASHBOARD_LIST_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "DASHBOARD_LIST_SET_ITEMS"
export const SET_CURRENT_ITEM = "DASHBOARD_LIST_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "DASHBOARD_LIST_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "DASHBOARD_LIST_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "DASHBOARD_LIST_SET_HIDE_MODAL"


export const SET_MODAL = "DASHBOARD_LIST_SET_MODAL"
export const SET_MODAL_CONTENT = "DASHBOARD_LIST_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "DASHBOARD_LIST_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "DASHBOARD_LIST_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "DASHBOARD_LIST_SET_MODAL_TYPE"